export const px = value => typeof value === 'number' ? "".concat(value, "px") : value;
export const selectColor = (theme, colorKey) => {
  return theme.color[colorKey];
};
export const selectColorOrNull = (theme, colorKey) => {
  if (colorKey === undefined) {
    return null;
  }
  const color = theme.color[colorKey];
  return color === undefined ? null : color;
};
export const selectFontFamily = function (theme) {
  let fontKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  const fontFamily = theme.font[fontKey];
  return fontFamily === undefined ? null : fontFamily.family;
};
const selectFontDetails = function (theme, sizeKey) {
  let {
    font = 'primary',
    breakpoint = 'l'
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (sizeKey === undefined) {
    return null;
  }
  const themeFont = theme.font[font];
  if (!(themeFont !== null && themeFont !== void 0 && themeFont.size)) {
    return null;
  }
  const fontSizeConfig = themeFont.size[sizeKey];
  if (!fontSizeConfig) {
    return null;
  }
  const breakpointConfig = fontSizeConfig[breakpoint];
  return breakpointConfig || null;
};
export const selectFontSize = function (theme, sizeKey) {
  let {
    font = 'primary',
    breakpoint = 'l'
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (sizeKey === undefined) {
    return null;
  }
  const fontDetails = selectFontDetails(theme, sizeKey, {
    font,
    breakpoint
  });
  return fontDetails ? px(fontDetails.fontSize) : null;
};
export const selectLineHeight = function (theme, sizeKey) {
  let {
    font = 'primary',
    breakpoint = 'l'
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (sizeKey === undefined) {
    return null;
  }
  const fontDetails = selectFontDetails(theme, sizeKey, {
    font,
    breakpoint
  });
  return fontDetails ? fontDetails.lineHeight : null;
};
export const selectFontWeight = function (theme, fontWeightKey) {
  let {
    font = 'primary'
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (fontWeightKey === undefined) {
    return null;
  }
  const themeFont = theme.font[font];
  if (!(themeFont !== null && themeFont !== void 0 && themeFont.fontWeight)) {
    return null;
  }
  const weight = themeFont.fontWeight[fontWeightKey];
  return weight !== null && weight !== void 0 ? weight : null;
};
export const selectSpace = (theme, sizeName) => {
  if (sizeName === undefined) {
    return null;
  }
  const space = theme.space[sizeName];
  return space === undefined ? null : space;
};
export const selectConstant = (theme, constantName) => {
  return theme.constants[constantName];
};
export const selectBreakpoint = (theme, sizeName) => {
  var _theme$breakpoint;
  if (sizeName === undefined) {
    return null;
  }
  return (_theme$breakpoint = theme.breakpoint[sizeName]) !== null && _theme$breakpoint !== void 0 ? _theme$breakpoint : null;
};
export const selectZIndex = (theme, componentName) => {
  if (componentName === undefined) {
    return null;
  }
  const zIndex = theme.zIndex[componentName];
  return zIndex === undefined ? null : zIndex;
};
export const selectRadius = (theme, size) => {
  return theme.radius[size] || 0;
};